import { useQuery } from '@tanstack/react-query';

import * as cmsServices from '../../services';

export const useGetCharities = ({ params = {}, options = {} } = {}) => {
  const { filters: { keys } = {}, pagination: { page } = {} } = params;

  return useQuery(['charities', keys, page], () => cmsServices.getCharities(params), options);
};
